const preventInvalidChars = (event) => {
  const invalidChars = ["e", "E", "+", "-"];
  if (invalidChars.includes(event.key)) {
    event.preventDefault();
  }
};
export default preventInvalidChars;